import { useNavigate } from 'react-router';
import { toast } from '@lib/ui';
import type { WizardPersona } from '../types';
import { LivePreviewWizard } from './index';

export default function LivePreviewWizardPage() {
  const navigate = useNavigate();

  const handleComplete = (persona: WizardPersona) => {
    toast.success(`Persona "${persona.name}" created successfully!`);
    navigate('/personas');
  };

  const handleCancel = () => {
    navigate('/poc/wizards');
  };

  return <LivePreviewWizard onComplete={handleComplete} onCancel={handleCancel} />;
}
